// assets
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';

// icons
const icons = { FileTextOutlined };

// ==============================|| MENU ITEMS - FEE GUIDES ||============================== //

const feeGuides = {
  id: 'fee_guides',
  title: 'Fee Guides',
  type: 'item',
  url: '/fee-guides',
  icon: icons.FileTextOutlined,
  permission: {
    module: 'fee_guides',
    level: 10 // View permission required
  }
};

export default feeGuides;

